import React from "react";
import "./lucky-draw-style.css";

export default function LuckyDrawTicket({ number, name }) {
  return (
    <div className="ticket-container" style={{ marginBottom: 15 }}>
      <center style={{ padding: 37, fontSize: 34, display: "flex", flexDirection: "column", gap: 10, alignItems: "center", justifyContent: "center" }}>
        <div style={{ fontSize: 20, whiteSpace: "nowrap" }}>หมายเลขชิงรางวัล</div>
        <b>{number ?? 999}</b>
      </center>
      <div className="ticket-right">
        <div style={{ transform: "rotate(-90deg)", whiteSpace: "nowrap", marginLeft: "60%" }}>{name ?? "-"}</div>
      </div>
    </div>
  );
}
